var render = function render(){
  var _vm$lists$formacoes;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "1000"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(" Listagem de Formações ")])]), _c('div', {
    staticClass: "container dialog mt-4"
  }, [_c('h3', [_vm._v(" Listagem de Formações ")]), _c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-data-table', {
    staticClass: "mt-5",
    staticStyle: {
      "min-width": "800px"
    },
    attrs: {
      "headers": _vm.headers,
      "items": _vm.lists.formacoes,
      "items-per-page": 10,
      "show-expand": "",
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: "expanded-item",
      fn: function (_ref) {
        var headers = _ref.headers,
          item = _ref.item;
        return [_c('td', {
          staticClass: "pa-4",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-simple-table', {
          attrs: {
            "dense": ""
          }
        }, [_c('tbody', _vm._l(item.see, function (see, i) {
          return _c('tr', {
            key: i
          }, [_c('td', [_vm._v(_vm._s(see.nome))])]);
        }), 0)])], 1)];
      }
    }])
  })], 1)], 1), _c('v-row', {
    staticClass: "pl-8 pr-8 mt-n4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "formacao-info"
  }, [_vm._v("Quantidade de Formações: " + _vm._s(((_vm$lists$formacoes = _vm.lists.formacoes) === null || _vm$lists$formacoes === void 0 ? void 0 : _vm$lists$formacoes.length) || 0))]), _c('p', {
    staticClass: "formacao-info"
  }, [_vm._v("Total de Carga Horária: " + _vm._s(_vm.totalCargaHoraria) + "h")])])], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-4 mb-4",
    staticStyle: {
      "gap": "2rem"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v("Voltar")]), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.baixarRelatorioPdf
    }
  }, [_vm._v("Exportar")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }